import React, { useEffect } from "react";
import { BsCalendarEvent } from "react-icons/bs";
import useEvents from "./hooks/useEvents";
import EventSingle from "./SingleEvent";
import "./style.scss";
import { useTranslation } from "react-i18next";
import useFacility from "../../../utils/hooks/useFacility";
import { useSelector } from "react-redux";
import { State } from "../../store";

const EventSale: React.FC = () => {
  const { t } = useTranslation();
  const { getEventExercises, exercise  } = useEvents();
  const facilityIds = useFacility();
  const messageEvents = useSelector((state: State) => state.config.configuration.message_events);
  
  useEffect(() => {
    getEventExercises()
  }, [facilityIds]);


  
  return (
    <React.Fragment>

{messageEvents && (
          <React.Fragment>
            {messageEvents.length > 12 ? (
              <div className="alert alert-comment">
                <article dangerouslySetInnerHTML={{ __html: messageEvents }}></article>
              </div>
            ) : (
              <React.Fragment></React.Fragment>
            )}
          </React.Fragment>
        )}

      {exercise.length > 0 ? (
        <div>
          {exercise.map((item, index) => (
            <div className={"event-block"} key={index}>
              <EventSingle item={item}  />
            </div>
          ))}
        </div>
      ) : (
        <div className="alert alert-yellow">
          <BsCalendarEvent className="alert-icon" />
          <b>{t("aktualnie_brak_nadchodzacych_wydarzen")}</b>
        </div>
      )}
    </React.Fragment>
  );
};

export default EventSale;
